// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"474ad478","203":"f14a7073","808":"2fcbf058"}[chunkId] + ".chunk.js";
};